import { NavigateFunction } from "react-router";

import { LoginSource, UserGroup } from "@/src/auth/auth";
import {
  getAuctionCreateRoute,
  getAuctionEditRoute
} from "@/src/constants/routes";
import { UserDTO, VehicleType } from "@/src/types/types";

import wretch from "wretch";

export const onAuctionListingClick = (
  source: LoginSource,
  isAuthenticated: boolean,
  draftAuction: number | undefined,
  activeAuction: number | undefined,
  navigate: NavigateFunction,
  user: UserDTO | null | undefined,
  sendDataToGTM: (data: object) => void,
  login: (userGroup: UserGroup, source: LoginSource) => void,
  vehicleType: VehicleType
) => {
  const wizardCreate = getAuctionCreateRoute(vehicleType);
  const wizardEdit = getAuctionEditRoute(vehicleType);

  if (!isAuthenticated) {
    sendDataToGTM({
      event: "login_clicked",
      button_name: source
    });
    navigate(wizardCreate);
    // If logged in and has draft of current vehicle type, continue draft
  } else if (isAuthenticated && draftAuction) {
    sendDataToGTM({
      event: "draft_auction_clicked",
      button_name: source,
      user: user
    });
    navigate(`${wizardEdit}/${draftAuction}`);
    // If logged in but no draft of current type, create new auction
    // Users can have multiple auctions, so we don't block based on active auctions
  } else if (isAuthenticated && !draftAuction) {
    sendDataToGTM({
      event: "new_auction_clicked",
      button_name: source,
      user: user
    });
    navigate(wizardEdit);
  }
};

export const auctionClickNavigation = (
  isAuthenticated: boolean,
  draftAuction: number | undefined,
  navigate: NavigateFunction,
  login: (userGroup: UserGroup, source: LoginSource) => void,
  vehicleType: VehicleType
) => {
  const wizardCreate = getAuctionCreateRoute(vehicleType);
  const wizardEdit = getAuctionEditRoute(vehicleType);
  if (!isAuthenticated) {
    navigate(wizardCreate);
  } else if (isAuthenticated) {
    navigate(draftAuction ? `${wizardEdit}/${draftAuction}` : wizardEdit);
  }
};

const SOLDCARS_URL = import.meta.env.VITE_FRONTPAGE_SOLDCARS_URL;

export interface CarData {
  url: string;
  model: string;
  price: number;
}

export const fetchCarData = async (): Promise<CarData[]> => {
  try {
    const response: CarData[] = await wretch(SOLDCARS_URL)
      .headers({
        "cache-control": "public, max-age=3600"
      }) // instructs CDN to cache for 1 hour
      .get()
      .json();
    return response;
  } catch (error) {
    console.error("Error fetching data:", error);
  }
  return [];
};
